import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Home from './pages/Home';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import AdminPage from './pages/AdminPage';
import ErrorBoundary, { installGlobalErrorHandlers } from './components/ErrorBoundary';
import WhatsAppFloat from './components/WhatsAppFloat';
import './App.css';

// Hide floating WhatsApp on internal admin routes
const FloatingChat = () => {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return null;
  return <WhatsAppFloat />;
};

function App() {
  useEffect(() => {
    installGlobalErrorHandlers();
  }, []);
  
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmationPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <FloatingChat />
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
